<div class="content-all">
    <div class="header">
        <h1 class="header-title">
            <mat-icon class="header-icon">dashboard</mat-icon>
            {{'dashboard.manager.title' | translate}}
        </h1>

        <lib-button (click)="cancel()" icon="close" color="none" textColor="muted"
            tooltip="{{'form.close' | translate}}">
        </lib-button>
    </div>

    <div mat-dialog-content class="content-dialog">
        <!-- No data -->
        <div *ngIf="dashboardList().length === 0" class="no-data">
            <lib-no-data icon="dashboard" message="dashboard.empty.no_dashboard_created"
                description="dashboard.empty.create_first">
                <div class="btn-action">
                    <lib-button color="primary" (click)="addDashboard()" icon="add"
                        [text]="'dashboard.manager.add' | translate">
                    </lib-button>

                    <lib-button color="secondary" (click)="import()" icon="import_export"
                        [text]="'dashboard.manager.import' | translate">
                    </lib-button>
                </div>
            </lib-no-data>
        </div>

        <!-- Dashboard list -->
        <div class="list-dashboard">
            <ng-container *ngIf="dashboardList().length > 0">
                <div class="list-dash" cdkDropList (cdkDropListDropped)="onDrop($event)">
                    <ul>
                        <li *ngFor="let dashboard of dashboardList(); let index = index"
                            (click)="handleClick(dashboard.id)"
                            [ngClass]="{'selected': dashboard.id === currentDashboard()?.id}" cdkDrag>
                            <div class="dashboard-item">
                                <div class="dashboard-title">
                                    <mat-icon
                                        [fontIcon]="(index + 1) > 9 ? 'filter_9_plus' : 'filter_' + (index + 1)"></mat-icon>
                                    {{ dashboard.title }}
                                </div>

                                <div class="list-button">
                                    <lib-button *ngIf="dashboard.projects.length > 1" mat-icon-button color="none"
                                        icon="link" textColor="muted">
                                    </lib-button>

                                    <lib-button color="none" textColor="secondary" icon="content_copy"
                                        (click)="duplicateDashboard(dashboard); $event.stopPropagation()">
                                    </lib-button>

                                    <lib-button (click)="deleteDashboard(dashboard); $event.stopPropagation()"
                                        *ngIf="canManageProject()" icon="delete" color="none" textColor="danger">
                                    </lib-button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div mat-dialog-actions class="btn-action">
                    <div>
                        <lib-button color="primary" class="space-btn" (click)="addDashboard()" icon="add"
                            [text]="'dashboard.manager.add' | translate">
                        </lib-button>

                        <lib-button color="secondary" (click)="import()" icon="import_export"
                            [text]="'dashboard.manager.import' | translate">
                        </lib-button>
                    </div>
                </div>
            </ng-container>
        </div>

        <div class="edit-dash" *ngIf="currentDashboard()">
            <!-- Section Configuration Générale -->
            <div class="config-section">
                <h3 class="section-title">
                    <mat-icon class="section-icon">settings</mat-icon>
                    {{'dashboard.manager.general_settings' | translate}}
                </h3>

                <div class="form-group">
                    <div class="name-field-container">
                        <mat-form-field class="flex-1" appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{'dashboard.manager.name' | translate}}</mat-label>
                            <input matInput (blur)="save()" [(ngModel)]="currentDashboard().title">
                            <mat-icon matPrefix>dashboard</mat-icon>
                        </mat-form-field>

                        <lib-button color="none" textColor="muted" class="unlink-btn" (click)="unlink()"
                            *ngIf="currentDashboard().projects.length > 1" icon="link_off"
                            tooltip="{{'dashboard.manager.unlink_dashboard' | translate}}">
                        </lib-button>
                    </div>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{'dashboard.manager.description' | translate}}</mat-label>
                        <textarea matInput rows="3" (blur)="save()"
                            [(ngModel)]="currentDashboard().description"></textarea>
                        <mat-icon matPrefix>description</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <!-- Section Actualisation Automatique -->
            <div class="config-section">
                <h3 class="section-title">
                    <mat-icon class="section-icon">schedule</mat-icon>
                    {{'dashboard.manager.auto_refresh' | translate}}
                </h3>

                <div class="refresh-controls">
                    <mat-form-field class="refresh-value" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{'dashboard.manager.count' | translate}}</mat-label>
                        <input type="number" min="1" max="999" (blur)="save()" matInput
                            [(ngModel)]="currentDashboard().autoRefresh.value">
                        <mat-icon matPrefix>timer</mat-icon>
                    </mat-form-field>

                    <mat-form-field class="refresh-unit" appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{'dashboard.manager.unit' | translate}}</mat-label>
                        <mat-select (selectionChange)="save()" [(ngModel)]="currentDashboard().autoRefresh.unit">
                            <mat-option value="minute">
                                <mat-icon>access_time</mat-icon>
                                {{'form.minutes' | translate}}
                            </mat-option>
                            <mat-option value="hour">
                                <mat-icon>schedule</mat-icon>
                                {{'form.hours' | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Section Paramètres du Projet -->
            <div class="config-section project-settings">
                <h3 class="section-title">
                    <mat-icon class="section-icon">tune</mat-icon>
                    {{'dashboard.manager.project_settings' | translate}}
                </h3>

                <div class="form-group">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{'form.displayName' | translate}}</mat-label>
                        <input matInput (blur)="save()"
                            [(ngModel)]="currentDashboard().projectSettings[currentProjectIndex].title">
                        <mat-icon matPrefix>label</mat-icon>
                    </mat-form-field>

                    <div class="form-row">
                        <mat-form-field class="flex-2" appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{'dashboard.manager.mailing_list' | translate}}</mat-label>
                            <mat-select (selectionChange)="onSelectionChange($event); save()"
                                [(ngModel)]="currentDashboard().projectSettings[currentProjectIndex].mailingList"
                                multiple>
                                <mat-option *ngFor="let user of optionsList" [value]="user.id">
                                    <mat-icon>person</mat-icon>
                                    {{ user.email }}
                                </mat-option>
                            </mat-select>
                            <mat-icon matPrefix>email</mat-icon>
                        </mat-form-field>

                        <mat-form-field class="flex-1" appearance="outline" subscriptSizing="dynamic">
                            <mat-label>{{'dashboard.manager.frequency' | translate}}</mat-label>

                            <mat-select (selectionChange)="save()"
                                [(ngModel)]="currentDashboard().projectSettings[currentProjectIndex].reportFrequency">
                                <mat-option value="never">
                                    <mat-icon>block</mat-icon>
                                    {{'form.never' | translate}}
                                </mat-option>

                                <mat-option value="daily">
                                    <mat-icon>today</mat-icon>
                                    {{'date.day' | translate}}
                                </mat-option>

                                <mat-option value="weekly">
                                    <mat-icon>date_range</mat-icon>
                                    {{'date.week' | translate}}
                                </mat-option>

                                <mat-option value="monthly">
                                    <mat-icon>event</mat-icon>
                                    {{'date.month' | translate}}
                                </mat-option>
                            </mat-select>

                            <mat-icon matPrefix>schedule_send</mat-icon>
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <mat-label>{{'dashboard.manager.units' | translate}}</mat-label>

                        <mat-select (selectionChange)="onSelectionChange($event); save()"
                            [(ngModel)]="currentDashboard().projectSettings[currentProjectIndex].units" multiple>
                            <mat-option *ngFor="let unit of units" [value]="unit.name">
                                <mat-icon>track_changes</mat-icon>
                                {{ unit.name }}
                            </mat-option>
                        </mat-select>

                        <mat-icon matPrefix>track_changes</mat-icon>
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
</div>